import React from "react";
import { motion } from "framer-motion";
import site1 from "../Assets/site1.jpg";
import site2 from "../Assets/site2.jpg";
import site3 from "../Assets/site3.jpg";
import site4 from "../Assets/site4.jpg";
import site5 from "../Assets/site5.jpg";
import site6 from "../Assets/site6.jpg";
import site7 from "../Assets/site1.jpg";

const images = [site1, site2, site3, site4, site5, site6, site7];

const InfiniteCarousel = () => {
  return (
    <div className="relative w-full overflow-hidden blue-bg">
      <motion.div
        className="flex my-2"
        initial={{ x: 0 }}
        animate={{
          x: ["-100%", "0%"],
          transition: {
            ease: 'linear',
            duration: 10,
            repeat: Infinity,
        }
        }}
        // transition={{
        //   ease: "linear",
        //   duration: 10,
        //   repeat: Infinity,
        // }}
        style={{ display: "flex", width: "fit-content" }}
      >
        {[...images, ...images].map((src, index) => (
          <div key={index} className="mx-2" style={{ minWidth: "300px" }}>
            <img
              src={src}
              alt={`Carousel ${index}`}
              className="rounded shadow"
              style={{ width: "100%", height: "200px", objectFit: "cover" }}
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default InfiniteCarousel;